<template>
  <google-avis-module :avis="avis" />
</template>

<script>
import GoogleAvisModule from "../../../components/modules/avis/googleAvisModule.vue";
import { sendGraphQLRequest } from "../../../utils/sendGraphQLRequest";

export default {
  name: "GoogleAvisPanel",
  components: { GoogleAvisModule },
  props: {
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      numberItem: 5,
      avis: [],
    };
  },
  mounted() {
    this.envoyerRequete();
  },
  methods: {
    async envoyerRequete() {
      try {
        const { sendRequest } = sendGraphQLRequest();
        const query = `
          query {
            retrieveGoogleReviews(numberItem: ${this.numberItem}) {
              reviews {
                comment
                starRating
                createAt
                updateAt
                reviewer {
                  profilePhotoUrl
                  displayName
                }
              }
              averageRating
              totalReviewCount
            }
          }
        `;
        const result = await sendRequest(query);
        this.avis = result.data.retrieveGoogleReviews || [];
      } catch (error) {
        console.error("Erreur retrieveGoogleReviews GraphQL :", error);
      }
    },
  },
};
</script>
